import * as t from 'io-ts';
import _ from 'lodash';

import {makeApiType} from './apiTypes';
import {parseCardGroup, RCardGroup} from './cardGroupModel';
import {CardModel, parseCard, RCard} from './cardModel';
import {parseContact, RContact} from './contactModel';

/*
 * Runtime type.
 */

const RSearchCardsDirty = t.readonly(
  t.type({
    limit: t.Integer,
    cards: t.readonlyArray(RCard),
    contacts: t.readonlyArray(RContact),
  }),
);

const RSearchNamespacedCardsDirty = t.readonly(
  t.type({
    limit: t.Integer,
    cards: t.readonlyArray(RCard),
    contacts: t.readonlyArray(RContact),
    cardGroups: t.readonlyArray(RCardGroup),
  }),
);

/*
 * Type.
 */

export type SearchCardModel = ReadonlyArray<CardModel>;
export interface SearchCardsModel extends t.TypeOf<typeof RSearchCardsDirty> {}
export interface SearchNamespacedCardsModel extends t.TypeOf<typeof RSearchNamespacedCardsDirty> {}
export const RSearchCards = t.clean<SearchCardsModel>(RSearchCardsDirty as any);
export const RSearchNamespacedCards = t.clean<SearchNamespacedCardsModel>(RSearchNamespacedCardsDirty as any);

/*
 * IO methods.
 */

function parseSearchCards(src: any): SearchCardsModel {
  return {
    limit: src.limit,
    cards: src.cards && src.cards.map((card: any) => parseCard(card)),
    contacts:
      src.cards &&
      _(src.cards)
        .map((card) => card.contacts ?? [])
        .flatten()
        .map((contact) => parseContact(contact))
        .value(),
  };
}

function parseSearchNamespacedCards(src: any): SearchNamespacedCardsModel {
  return {
    limit: src.limit,
    cards: src.cards && src.cards.map((card: any) => parseCard(card)),
    contacts:
      src.cards &&
      _(src.cards)
        .map((card) => card.contacts ?? [])
        .flatten()
        .map((contact) => parseContact(contact))
        .value(),
    cardGroups:
      src.cards &&
      _(src.cards)
        .map((card) => card.groups ?? [])
        .flatten()
        .map((group) => parseCardGroup(group))
        .value(),
  };
}

/*
 * API type.
 */

export const ApiSearchCards = makeApiType('searchCards', RSearchCards, parseSearchCards);
export const ApiSearchNamespacedCards = makeApiType(
  'searchNamespacedCards',
  RSearchNamespacedCards,
  parseSearchNamespacedCards,
);
